import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'stripHtml'
})
export class StripHtmlPipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    if (!value) return '';

    // preserve <br> as real line breaks before stripping tags
    const withLineBreaks = value.replace(/<br\s*\/?>/gi, '\n');

    const div = document.createElement('div');
    div.innerHTML = withLineBreaks;

    return (div.textContent ?? div.innerText ?? '').trim();
  }

}
